import {Component} from '@angular/core';
import {AlertController, LoadingController, NavController} from 'ionic-angular';
import {SalesOrdersPage} from "../sales-orders/sales-orders";
import {LogoutPage} from "../logout/logout";
import {AuthProvider} from "../../providers/auth/auth";
import {LoginQrCodePage} from "../login-qr-code/login-qr-code";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {ToastProvider} from "../../providers/toast/toast";
import {SaleOrderPage} from "../sale-order/sale-order";
import {SaleOrderProvider} from "../../providers/sale-order/sale-order";
import {ConfigProvider} from "../../providers/config/config";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(
    public navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private auth: AuthProvider,
    private alertCtrl: AlertController,
    private barcodeScanner: BarcodeScanner,
    private toast: ToastProvider,
    private salesOrderProvider: SaleOrderProvider
  ) {
  }

  ionViewDidLoad() {
    this.loadWhoAmI();
  }

  async loadWhoAmI() {
    let loading = this.loadingCtrl.create({content: "Benutzereinstellungen werden geladen, bitte warten ..."});
    loading.present();

    await this.auth.getWhoami();

    loading.dismiss();

    this.checkWhoAmI();
  }

  checkWhoAmI() {
    // Logout if did not get whoami info
    if (!this.auth.whoami || !this.auth.whoami.name) {
      this.alertCtrl.create({
        title: 'Anmeldung fehlgeschlagen!',
        subTitle: 'Die aktuelle Sitzung ist nicht mehr gültig, bitte melden Sie sich neu an.',
        buttons: [
          {
            text: 'OK',
            handler: data => {
              this.navCtrl.setRoot(LogoutPage);
            }
          }
        ]
      }).present();
    }
  }

  scanSaleOrder() {
    this.barcodeScanner.scan().then(barcodeData => {
      this.goToSaleOrder(barcodeData.text);
    }).catch(err => {
      this.toast.error('Barcode kann nicht gelesen werden. Fehler: '+err);
    });
  }

  async goToSaleOrder(name) {
    let salesOrder = await this.salesOrderProvider.get(name);

    // @ts-ignore
    if (!salesOrder.id) {
      this.toast.error('Auftrag '+name+' konnte nicht gefunden werden.');
    } else {
      this.navCtrl.push(SaleOrderPage, {name: name});
    }
  }

  goToSalesOrders() {
    this.navCtrl.push(SalesOrdersPage);
  }

  goToLogout() {
    this.navCtrl.setRoot(LogoutPage);
  }

  goToLoginQrCode() {
    this.navCtrl.push(LoginQrCodePage);
  }

  goToHolidayRequest() {

  }

  goToLeaveRequest() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts